
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, unknown> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    // default export の場合
    if (module.default && typeof module.default === 'object') {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...(module.default as Record<string, unknown>),
      };
    }

    // named export の場合（default 以外のキーをすべてマージ）
    Object.keys(module).forEach((key) => {
      if (key !== 'default' && typeof module[key] === 'object') {
        messages[lang].translation = {
          ...messages[lang].translation,
          ...(module[key] as Record<string, unknown>),
        };
      }
    });
  }
});

export default messages;
